export default "__VITE_ASSET__DYzGLmkP__"